/* global reportDimensionApi, monthEndIso, reportMonthIndex, addTrialAmount, addPostingLinesToReport, nbToIso, num */
// Rapporter fra lesemodellen for saldoer per maaned (ledgerBalances.js; hastighetssporet S3).
// Hjelperne her brukes av backend-accounting-engine.jsx (saldobalanse, resultat, graf),
// backend-vat-report.jsx (MVA-melding) og modellene som avgjor om en rapport kan svares fra
// modellen mens journalen fortsatt lastes. De er rene funksjoner over `state`; lastes som
// klassisk script sammen med motoren, og kalles bare ved kjoring, aldri ved innlasting.
// Ledger balances read model (ledgerBalances.js, speed track S3): the month documents replace the
// journal replay when the model is current, no dimension filter is active and the range is
// month-aligned. Anything else keeps the journal path, so the numbers never change meaning.
const ledgerMonthStart = (month) => `${month}-01`;
const monthAligned = (options = {}) => {
  const from = options.from ? nbToIso(options.from) : '';
  const to = options.to ? nbToIso(options.to) : '';
  if (from && from.slice(8, 10) !== '01') return false;
  if (to && to !== monthEndIso(Number(to.slice(0, 4)), Number(to.slice(5, 7)) - 1)) return false;
  return true;
};
const ledgerBalancesFor = (state, year, options = {}) => (window.PlummeLedgerBalances?.ledgerBalancesUsable?.(state) && window.PlummeJournalDemand.readModelVerified(state, year, options) && !reportDimensionApi().active(options) && monthAligned(options)
  ? state.ledgerBalancesByMonth : null);
const ledgerMonthsInRange = (balances, year, options) => Object.keys(balances).sort().filter((month) => reportMonthIndex(ledgerMonthStart(month), year, options) >= 0);
const ledgerYearMonths = (balances, year, options) => Object.keys(balances).sort().filter((month) => (options.fiscalBounds
  ? ledgerMonthStart(month) >= options.fiscalBounds.from && ledgerMonthStart(month) <= options.fiscalBounds.to : Number(month.slice(0, 4)) === year));
// Opening-balance postings of the year's months, shaped like the journal vouchers the engine filters.
const ledgerOpeningVouchers = (balances, year, options) => ledgerYearMonths(balances, year, options)
  .flatMap((month) => Object.entries(balances[month].opening || {}).map(([nr, cents]) => ({ sourceType: 'openingBalance', postings: [{ nr, amount: num(cents) / 100 }] })));
// Result and chart: every posting of each month in range, opening balances included.
const addLedgerPostingsToReport = (state, balances, year, options, mapsFor) => {
  for (const month of Object.keys(balances).sort()) {
    const monthIndex = reportMonthIndex(ledgerMonthStart(month), year, options);
    if (monthIndex >= 0) addPostingLinesToReport(state, Object.entries(balances[month].accounts || {}).map(([nr, cents]) => ({ nr, amount: num(cents) / 100 })), mapsFor(monthIndex));
  }
};
const addLedgerMovementsToTrial = (map, state, balances, year, options) => {
  for (const month of ledgerMonthsInRange(balances, year, options)) {
    const { accounts = {}, opening = {} } = balances[month];
    for (const code of Object.keys(accounts)) addTrialAmount(map, state, code, (num(accounts[code]) - num(opening[code])) / 100);
  }
};
